namespace('compass.hotel');

compass.require('compass.hotel.StarRatingWidget');
compass.requireLib('compass.util.format');

compass.hotel.HotelCardWidget = compass.defineWidget(function HotelCardWidget(options) {
	var me = this;
	var d = jQuery.dom;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;

	var _hotel = _settings.hotel;
	var _reservations = _settings.reservations;
	var _defaultImage = compass.staticPrefix + "/resources/img/compass/hotel/nomainimage.jpg";
	var _ids = {
		hotelName: compass.generateId()
	};

	// TODO: Remove this random assignment once backend passes categoryPreferredHotel
	_hotel.categoryPreferredHotel = _hotel.categoryPreferredHotel || false; //Math.random() > 0.5;
	_hotel.preferredCategoryMessage = _hotel.preferredCategoryMessage || '';
	
	// lowestAvgRateNumeric will === -1 only in the case that eps returned no availability for a hotel
	// In that case disable the display of most of the things on the card
	if (_hotel.avail !== undefined && _hotel.avail.lowestAvgRateNumeric < 0) {
		_settings.showAverageRate = false;
		if (!_settings.meetingInfo.showSimplifiedHotelFilter) {
			_settings.displayHotelStars = false;
			_settings.hideDistance = true;
		}
	}

	var _cf = compass.util.currencyFormatter(_settings.meetingInfo.currencyCode,
		{ showDecimals : 0 });

	this.render = function(widgetElem) {
		if (_settings.compactLayout) {
			return me.renderCompactMapLayout(widgetElem);
		}
		
		var classes = 'hotelCard hotel_id_' + _hotel.hotelId;

		if(_hotel.categoryPreferredHotel) {
			classes += ' preferredCategoryHotel';
		} else if(_hotel.hqHotel) {
			classes += ' headquartersHotel';
		}

		if(_settings.showAvailability) {
			if(_hotel.avail.status === 'SOLDOUT') {
				classes += ' soldOut';
				widgetElem.activate(function() {
					d.alert('This hotel is not available');
				});
			} else {
				widgetElem.activate(function() {
					me.trigger('HotelCard.hotelClicked', {
						hotel : _hotel,
						avail : _hotel.avail
					});
				});
			}
		}

		var roomsBookedLabel = '';
		if(_reservations.length) {
			var numberOfRooms = _.foldl(_reservations, function(acc, reservation) {
				return acc + reservation.numberOfRooms;
			}, 0);
			roomsBookedLabel = numberOfRooms + (numberOfRooms == 1 ? ' Room Booked' : ' Rooms Booked');
			classes += ' hasRoomsBooked';
		}

		
		var headquartersText = 'HQ';
		if (_settings.meetingInfo.showSimplifiedHotelFilter) {
			classes += ' simplified';
			headquartersText = 'Headquarters Hotel';
		}

		// Check if redesign is enabled
		if (compass.isRedesignEnabled()) {
			// Redesign layout
			widgetElem.append(
				d.div({ className : classes + ' redesign', tabindex : 0, 'role': 'button', 'aria-role' : 'button', 'aria-labelled': _ids.hotelName },
					me.drawSoldOut(_hotel),
					d.div( {className: 'hotelCardContent'},
						// Variable Rates badge (if applicable)
						_hotel.avail && _hotel.avail.hasVariableRates ? d.div({ className: 'variableRatesBadge' }, 'Variable Rates') : null,
						me.drawHotelImg(_hotel),
						me.drawHotelName(_hotel),
						// Star rating and distance on same line
						d.div({ className: 'ratingDistanceLine' },
							_settings.displayHotelStars && _hotel.starRating > 0 && me.drawHotelStarRatingRedesign(_hotel, _hotel.starRatingDecimal || _hotel.starRating),
							// Add separator if both star rating and distance are shown
							(_settings.displayHotelStars && _hotel.starRating > 0 && !_settings.hideDistance) ? d.span({ className: 'separator' }, '|') : null,
							!_settings.hideDistance && me.drawDistance(_hotel),
							d.div({ className : 'clear' })
						),
						// Availability info
						_settings.showAvailability ? me.drawAvailability(_hotel, _settings.availMin) : me.drawTotalRooms(_hotel),
						// Amenity features section (for redesign)
						me.drawAmenityFeatures(_hotel),
						// Price section at bottom
						(_settings.showAverageRate) ? d.div( {className: 'rateWrapper'}, me.drawRates(_hotel) ) : null,
						// Markers for booked rooms (HQ is now shown as badge in hotel name)
						d.div({ className : 'markers' },
							d.div({ className : 'roomsBooked marker' }, roomsBookedLabel),
							d.div({ className : 'clear' })
						)
					)
				)
			);
		} else {
			// Original layout
			widgetElem.append(
				d.div({ className : classes, tabindex : 0, 'role': 'button', 'aria-role' : 'button', 'aria-labelled': _ids.hotelName },
					me.drawSoldOut(_hotel),
					d.div( {className: 'hotelCardContent'},
						d.div({ className : 'markers' },
							d.div({ className : 'roomsBooked marker' }, roomsBookedLabel),
							d.div({ className : 'headquarters marker' }, d.abbr({title: 'Headquarters'}, headquartersText) ),
						d.div({ className : 'preferredCategory marker' },
							d.div({ className : 'preferredCategoryContent' },
								d.span({ className : 'preferredCategoryText' }, (_hotel.preferredCategoryLabel || 'Preferred Hotel')),
								(_hotel.preferredCategoryMessage && _hotel.preferredCategoryMessage.length > 0)
									? d.span({ className : 'preferredCatInfoImg', tabindex: 0, role: 'button' }).activate(function(evt) {
										evt.stopPropagation();
										d.alert({
											message: _hotel.preferredCategoryMessage,
											includeImage: false
										});
									})
									: null
							)
						),
							d.div({ className : 'clear' })
						),
						me.drawHotelName(_hotel),
						me.drawHotelImg(_hotel),
						(_settings.showAverageRate) ? d.div( {className: 'rateWrapper'}, me.drawRates(_hotel) ) : null,
						me.drawFooter(_hotel, _settings.availMin)
					)
				)
			);
		}
	};

	this.getHotel = function() {
		return _hotel;
	};

	this.drawFooter = function(hotel, availMin) {
		var starRatingDisplay;
		if(hotel.starRatingDecimal){
			starRatingDisplay = hotel.starRatingDecimal;
		} else {
			starRatingDisplay = hotel.starRating;
		}
		return d.div({ className : 'cardFooter' },
			_settings.showAvailability ? me.drawAvailability(_hotel, availMin) : me.drawTotalRooms(_hotel),
			d.div({className: 'inlineDistanceAndOrRating'},
				!_settings.hideDistance && me.drawDistance(_hotel),
				_settings.displayHotelStars && starRatingDisplay > 0 && me.drawHotelStarRating(_hotel, starRatingDisplay)
			)
		);
	};

	this.drawSoldOut = function(hotel) {
		var className = 'soldOutWrapper';
		if(!_settings.displayHotelStars) {
			className += ' noStars';
		}
		return d.div({ className : className },
			d.div({ className: 'soldOutMessage' }, _settings.labels.soldOut)
		);
	};

	this.drawRates = function(hotel) {
		var price;
		var hasAsterisk = false;
		if(_settings.showAvailability) {
			var priceTBD = d.abbr({ title : 'Price - to be determined' }, 'TBD');
			var avgRate = hotel.avail.showInclusiveLowestAvgRate ? (hotel.avail.inclusiveLowestAvgRateNumeric || hotel.avail.lowestAvgRateNumeric) : hotel.avail.lowestAvgRateNumeric;
			price = avgRate === 0 ? priceTBD : _cf(Math.round(avgRate));
			hasAsterisk = (hotel.avail.inclusiveLowestAvgRateNumeric || hotel.avail.lowestAvgRateNumeric) != hotel.avail.lowestAvgRateNumeric;
		} else {
			price = _cf(Math.round(hotel.avgRate));
		}

		// For redesign, format price on one line
		if (compass.isRedesignEnabled()) {
			// Extract just the numeric value for redesign
			var priceText = typeof(price) === 'object' ? price.text() : price.toString();
			var numericPrice = priceText.replace(/[^0-9]/g, '');

			var rateMsg = d.div({className:'ratedesc redesign'},
				'USD | avg/night'
			);
			if (hasAsterisk || hotel.avail.isServiceFeeIncluded === true) {
				rateMsg = d.div({className:'ratedesc redesign'},
					'nightly average | onPeak service fee included'
				);
			}

			// Price savings for redesign
			var priceSavingsDOM = null;
			if (_settings.meetingInfo.priceSavingsPercent && hotel.avail.status !== 'SOLDOUT') {
				var compareAtPrice = Math.round(hotel.avail.lowestAvgRateNumeric / (1.0 - _settings.meetingInfo.priceSavingsPercent ));

				priceSavingsDOM = d.div({className: 'priceSavingsText'},
					d.span({className: 'comparePrice'}, _settings.meetingInfo.currencySymbol + compareAtPrice),
					d.span({className: 'savingsAmount'}, 'Save ' + _settings.meetingInfo.currencySymbol + Math.round(compareAtPrice - hotel.avail.lowestAvgRateNumeric))
				);
			}

			return d.div({ className : "rate" },
				d.div({ className: 'priceLineRedesign' },
					d.span({ className: 'priceAmount' }, '$' + numericPrice),
					hasAsterisk ? d.sup('*') : null,
					d.span({ className: 'currencyCode' }, ' ' + _settings.meetingInfo.currencyCode)
				),
				rateMsg,
				_settings.displayPriceSavings && priceSavingsDOM
			);
		}

		// Original layout
		if (typeof(price) !== 'object') {
			price = price + ((hotel.avail.inclusiveLowestAvgRateNumeric || hotel.avail.lowestAvgRateNumeric) != hotel.avail.lowestAvgRateNumeric ? '*' : '');
		}

		// Price savings for legacy (original format)
		var priceSavingsDOM = null;
		if (_settings.meetingInfo.priceSavingsPercent && hotel.avail.status !== 'SOLDOUT') {
			var compareAtPrice = Math.round(hotel.avail.lowestAvgRateNumeric / (1.0 - _settings.meetingInfo.priceSavingsPercent ));

			priceSavingsDOM = d.div({className: 'priceSavingsText'},
				d.span({className: 'priceSavingsIcon'}, d.i({className:'fa-solid fa-dollar-circle'})),
				"Normally " + _settings.meetingInfo.currencySymbol + compareAtPrice
			);
		}

		var rateMsg = ((hotel.avail.inclusiveLowestAvgRateNumeric || hotel.avail.lowestAvgRateNumeric) != hotel.avail.lowestAvgRateNumeric ? d.div({className:'ratedesc'},d.abbr({className : 'includesResortFee'},'*Rate includes mandatory hotel fee'))  : null);
		if (hotel.avail.isServiceFeeIncluded === true) rateMsg = d.div({className:'ratedesc'},d.abbr({className : 'includesResortFee'},'*Rate includes onPeak service fee.'));

		return d.div({ className : "rate" },
			price,
			d.div({ className : 'ratedesc' },
				d.span({ 'aria-hidden' : true }, _settings.meetingInfo.currencyCode),
				' | ',
				d.abbr({ title : 'Average per night' }, 'avg/night'),
				d.reader('.')
			),
			rateMsg,
			_settings.displayPriceSavings ? priceSavingsDOM : null
		);
	};

	this.drawHotelImg = function(hotel) {
		var mainImage = hotel.images.main;
		var src = _defaultImage;
		if(mainImage && mainImage.imagePath.length > 0) {
			src = mainImage.imagePath;
		}
		var retryCount = 0;
		var imgElement = d.img({ className : "hotelImg", src : src, alt : '' });
		imgElement.on('error', function() {
			// just in case _defaultImage produces an error too, prevent infinite loop
			if (retryCount < 5) {
				brokenSrc = imgElement.attr('src');
				if (_settings.meetingInfo.trackHotelImageErrors) {
					var filterResults = _.filter(
						["FAKE_IMG_URL", "nomainimage"],
						function(keyword) {
							return brokenSrc.indexOf(keyword) > -1;
						}
					);
					// only log the error if the URL didnt match any of the filter keywords/phrases
					if (filterResults.length === 0) {
						eventData = {
							hotel_id: hotel.hotelId,
							image_url: brokenSrc
						};
						// log the broken URL to Keen
						jQuery.ajax({
							url : '/sendToKeen',
							type: 'POST',
							ignoreTimeout : true,
							data: JSON.stringify({ 'stream': 'compass_hotelImageError', eventData: eventData }),
							dataType: 'json',
							error: function(event) {} //If call fails, suppress
						});
					}
				}
				imgElement.attr('src', _defaultImage);
				retryCount++;
			}
		});
		return imgElement;
	};

	this.drawHotelName = function(hotel) {
		return d.div({ className : "hotelNameWrapper" },
			d.reader(d.p({id:  _ids.hotelName}, hotel.name)),
			d.middled(
				d.div({ className: 'hotelNameLine' },
					d.p({ className : "hotelName", 'aria-hidden' : 'true' }, hotel.name),
					// Add HQ badge for redesign if headquarters hotel
					(compass.isRedesignEnabled() && hotel.hqHotel) ? d.span({ className: 'hqBadge' }, 'HQ') : null
				)
			)
		);
	};

	this.drawHotelStarRating = function(hotel, starRatingDisplay) {
		var starRatingDOM = d.div({ className : "hotelStarRating" });
		// Only show label in legacy design
		if (!compass.isRedesignEnabled()) {
			starRatingDOM.append(d.div({className: 'label'}, "rating"));
		}
		var _starRatingWidget = new compass.hotel.StarRatingWidget(starRatingDOM, {
			WUID : 'StarRatingWidget_' + _WUID,
			stars : (hotel.status === 'SOLDOUT' ? 0 : starRatingDisplay )
		});
		return starRatingDOM;
	};

	this.drawHotelStarRatingRedesign = function(hotel, starRatingDisplay) {
		// For redesign, show simple text rating like "★ 4.5"
		var rating = hotel.status === 'SOLDOUT' ? 0 : starRatingDisplay;
		if (rating > 0) {
			return d.div({ className : "hotelStarRating" },
				d.span({ className: 'starRatingText' }, '★ ' + rating)
			);
		}
		return null;
	};

	this.drawDistance = function(hotel) {
		var distanceContent = [];
		
		// Only show label in legacy design
		if (!compass.isRedesignEnabled()) {
			distanceContent.push(d.div({className: 'label'}, "distance"));
		}
		
		// For redesign, format as "5 miles to event site"
		if (compass.isRedesignEnabled()) {
			distanceContent.push(
				d.div({ className: 'distanceText' }, 
					d.i({ className: 'fa fa-location-pin locationIcon' }),
					d.span({ className : "distanceValue" }, Number(hotel.distance).toFixed(1) + ' ' + hotel.distanceUnits + ' to event site')
				)
			);
		} else {
			distanceContent.push(
				d.div({},  	
					d.span({ className : "hotelDistanceVal" }, Number(hotel.distance).toFixed(1)),
					d.span('&nbsp;'),
					d.span({ className : "hotelDistanceUnit"}, hotel.distanceUnits)
				)
			);
		}
		
		return d.div({ className: 'hotelDistance'}, distanceContent);
	};

	
	
	function getAvailabilityMessage(hotel, availMinParam){
		var availMessage = '';
		var availMin = availMinParam || 0;
		
		if ( _settings.hideNumberOfRoomsAvailable === true ){
			return "&nbsp;";
		}
		
		if(hotel.avail.status == 'GDS' || (hotel.avail != undefined && hotel.avail.lowestAvgRateNumeric < 0)) {
			availMessage = _settings.labels.availGds;
		} else if( availMin > hotel.avail.maxOneBlockReservations && availMin <= hotel.avail.maxMultiBlockReservations) {
			availMessage = _settings.labels.availLimited;
		}
		else if(availMin <= hotel.avail.maxOneBlockReservations){
			availMessage = 'Up to ' + hotel.avail.maxMultiBlockReservations +
					(hotel.avail.maxMultiBlockReservations === 1 ? ' room' : ' rooms') + ' available';
		}
		return availMessage;
	}

	this.drawAvailability = function(hotel, availMinParam) {
		var availMin = availMinParam || 0;
		var hotelStatus = hotel.status;
		return d.div({ className : 'hotelAvailability' }, getAvailabilityMessage(hotel, availMin));
	};

	this.drawTotalRooms = function(hotel) {
		return d.div({ className : 'hotelTotalRooms' },
			d.span({className: 'totalRoomsValue'}, hotel.totalRooms), _settings.labels.totalRoomsReserved
		);
	};

	this.setData = function(hotel){
		_hotel = hotel;
	};

	this.redraw = function(hotel, availMinParam){
		var availMin = availMinParam || 0;
		this.setData(hotel);
		
		// redraw the rate
		var rateWrapper = me.find('.rateWrapper');
		rateWrapper.empty();
		rateWrapper.append(me.drawRates(hotel));

		// redraw the availability message
		me.find('.hotelAvailability').text(getAvailabilityMessage(hotel, availMin));
	};

	this.updateTotalRooms = function(totalRooms) {
		me.find('.hotelTotalRooms .totalRoomsValue').empty().append(totalRooms);
	};

	this.drawAmenityFeatures = function(hotel) {
		// Only show promotions in redesign
		if (!compass.isRedesignEnabled()) {
			return null;
		}
		
		// Check if hotel has promotions
		if (!hotel.promotions || hotel.promotions.length === 0) {
			return null;
		}
		
		var promotionItems = [];
		
		// Create promotion items from the promotions array
		for (var i = 0; i < hotel.promotions.length; i++) {
			var promo = hotel.promotions[i];
			promotionItems.push(
				d.div({ className: 'promotionItem' },
					d.i({ className: 'fa fa-award promotionIcon' }),
					d.span({ className: 'promotionText' }, promo.title)
				)
			);
		}
		
		return d.div({ className: 'promotionsSection' },
			promotionItems
		);
	};

	// Helper function to check if hotel is Expedia
	this.isExpediaHotel = function(hotel) {
		return hotel.avail && (hotel.avail.status === 'GDS' || (hotel.avail.affiliates && hotel.avail.affiliates.indexOf('EAN') !== -1));
	};
	
	// Helper function to get button text
	this.getButtonText = function(hotel) {
		if (hotel.avail && hotel.avail.status === 'SOLDOUT') {
			return 'Sold Out';
		} else if (me.isExpediaHotel(hotel)) {
			return 'Check Availability';
		} else {
			return 'Book Now';
		}
	};
	
	// Helper function to get availability text
	this.getAvailabilityText = function(hotel) {
		if (!hotel.avail) return '';
		
		if (hotel.avail.status === 'SOLDOUT') {
			return 'Sold Out';
		} else if (hotel.avail.status === 'LIMITED') {
			return 'Limited Availability';
		} else {
			return 'Available';
		}
	};
	
	// Helper function to get formatted distance text
	this.getDistanceText = function(hotel) {
		if (_settings.hideDistance || !hotel.distance) {
			return '';
		}
		return hotel.distance + ' ' + (hotel.distanceUnits || 'Miles');
	};
	
	// Helper function to get star rating display value
	this.getStarRatingDisplay = function(hotel) {
		return hotel.starRatingDecimal || hotel.starRating;
	};
	
	// Helper function to check if hotel has mandatory fee
	this.hasMandatoryFee = function(hotel) {
		return hotel.avail && (hotel.avail.inclusiveLowestAvgRateNumeric || hotel.avail.lowestAvgRateNumeric) != hotel.avail.lowestAvgRateNumeric;
	};

	// Helper function to get formatted rate text
	this.getRateText = function(hotel) {
		if (hotel.avail) {
			var avgRate = hotel.avail.showInclusiveLowestAvgRate ? (hotel.avail.inclusiveLowestAvgRateNumeric || hotel.avail.lowestAvgRateNumeric) : hotel.avail.lowestAvgRateNumeric;
			if (avgRate === 0) {
				return 'TBD';
			}
			var hasFee = me.hasMandatoryFee(hotel);
			return _cf(Math.round(avgRate)) + (hasFee ? '*' : '');
		}
		return '';
	};

	this.renderCompactMapLayout = function(widgetElem) {
		var classes = 'hotelCard mapboxCompact hotel_id_' + _hotel.hotelId;

		var splitViewEnabled = _settings.meetingInfo.showSideBySideGallery === true;

		if (splitViewEnabled) {
			classes += ' split-view';
		}

		// Reuse existing helper functions
		var starRatingDisplay = me.getStarRatingDisplay(_hotel);
		var starsDisplay = '';
		if (_settings.displayHotelStars && starRatingDisplay > 0) {
			starsDisplay = d.div({ className: 'starRating' },
				d.span({ className: 'stars' }, '★' + starRatingDisplay)
			);
		}

		var rateText = me.getRateText(_hotel);
		var isExpediaHotel = me.isExpediaHotel(_hotel);
		var buttonText = me.getButtonText(_hotel);
		
		var buttonClass = 'compactButton primary' + (isExpediaHotel && _hotel.avail.status !== 'SOLDOUT' ? ' long-text' : '');

		widgetElem.append(
			d.div({ className: classes },
				d.div({ className: 'compactHeader' },
					d.h3({ className: 'compactHotelName' }, _hotel.name),
					_hotel.hqHotel ? d.div({ className: 'compactHQLabel' }, 'HQ') : null
				),

				d.div({ className: 'compactMainContent' },
					d.div({ className: 'compactImageSection' },
						d.img({ 
							src: _hotel.images.main && _hotel.images.main.imagePath ? _hotel.images.main.imagePath : _defaultImage,
							alt: _hotel.name,
							className: 'compactHotelImage'
						})
					),

					d.div({ className: 'compactInfoSection' },
						d.div({ className: 'compactMainRow' },
							d.div({ className: 'compactLeftInfo' },
								d.div({ className: 'compactRateRow' },
									starsDisplay,
									d.div({ className: 'compactRate' }, rateText)
								),
								d.div({ className: 'compactSubtext' }, _settings.meetingInfo.currencyCode + ' avg/night'),
								d.div({ className: 'compactFeeText' }, me.hasMandatoryFee(_hotel) ? '*includes mandatory hotel fee' : '')
							),
							d.div({ className: 'compactButtonRow' },
								d.button({ className: buttonClass }, 
									d.i({ className: 'fa-regular fa-calendar calendar-icon' }),
									d.span(' ' + buttonText)
								).activate(function(e) {
									if (e && e.stopPropagation) {
										e.stopPropagation();
									}

									compass.GA.trackEvent('Split View', 'Hotel Card Interaction', 'Book Now');

									if (_hotel.avail.status !== 'SOLDOUT') {
										me.trigger('HotelCard.hotelClicked', {
											hotel: _hotel,
											avail: _hotel.avail
										});
									}
								}),
								d.button({ className: 'compactButton secondary viewRouteButton' }, 
									d.i({ className: 'fa-regular fa-route route-icon' }),
									d.span('View Route')
								).activate(function(e) {
									e.stopPropagation();
									e.preventDefault();
									
									var button = $j(this);
									var icon = button.find('i');
									var span = button.find('span');
									var buttonText = span.text().trim();
									
									if (buttonText === 'Hide Route') {
										button.toggleClass('showing-route', false);
										icon.toggleClass('fa-eye-slash', false).toggleClass('fa-route', true).toggleClass('route-icon', true);
										span.text('View Route');

										compass.GA.trackEvent('Split View', 'Hotel Card Interaction', 'Hide Route');

										me.trigger('HotelCard.hideRoute', {
											hotel: _hotel
										});
									} else {
										button.toggleClass('showing-route', true);
										icon.toggleClass('fa-route', false).toggleClass('fa-eye-slash', true).toggleClass('route-icon', false);
										span.text('Hide Route');

										compass.GA.trackEvent('Split View', 'Hotel Card Interaction', 'View Route');

										me.trigger('HotelCard.viewRoute', {
											hotel: _hotel,
											mode: 'none'
										});
									}
								})
							)
						)
					)
				)
			)
		);
	};

}, {
	WUID : 'defaultHotelCardWidgetWUID',
	widgetName : 'HotelCardWidget',
	reservations : [ ],
	displayHotelStars : true,
	meetingInfo : {},
	availMin : 0,
	showAvailability : true,
	showAverageRate: true,
	displayPriceSavings: false,
	hideNumberOfRoomsAvailable : false,
	compactLayout: false,
	labels : {
		soldOut : 'UNAVAILABLE',
		availGds : 'Check Availability',
		availLimited : 'Limited Availability',
		totalRoomsReserved : ' Rooms Reserved'
	}
});

